import mockAgeGroups from '../mockData/mockAgeGroups';
import { apiClient } from './apiClient';

class AgeGroupsService {
  constructor() {
    // nutzt apiClient
  }

  // Simuliert API-Verzögerung (kann später entfernt werden)
  async delay(ms = 100) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Alle Altersgruppen abrufen
  async getAllAgeGroups() {
    try {
      await this.delay();
      
      const result = await apiClient.get('/age-groups');
      
      return {
        success: true,
        data: result,
        total: Array.isArray(result) ? result.length : 0
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Altersgruppe nach ID abrufen
  async getAgeGroupById(id) {
    try {
      await this.delay();
      
      const result = await apiClient.get(`/age-groups/${id}`);
      
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe nach Name abrufen
  async getAgeGroupByName(name) {
    try {
      await this.delay();
      
      // Suche nach Altersgruppe mit diesem Namen
      const allAgeGroups = await this.getAllAgeGroups();
      if (!allAgeGroups.success) {
        throw new Error('Fehler beim Laden der Altersgruppen');
      }
      
      const ageGroup = allAgeGroups.data.find(ag => ag.name === name);
      
      if (!ageGroup) {
        return {
          success: false,
          error: 'Altersgruppe nicht gefunden',
          data: null
        };
      }

      return {
        success: true,
        data: ageGroup
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe für ein bestimmtes Alter finden
  async getAgeGroupForAge(age) {
    try {
      await this.delay();
      
      const result = await apiClient.get(`/age-groups/for-age/${age}`);
      
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppen nach Geschlecht abrufen (falls später benötigt)
  async getAgeGroupsByGender(gender) {
    try {
      await this.delay();
      
      // Suche nach Altersgruppen mit diesem Geschlecht
      const allAgeGroups = await this.getAllAgeGroups();
      if (!allAgeGroups.success) {
        throw new Error('Fehler beim Laden der Altersgruppen');
      }
      
      const ageGroups = allAgeGroups.data.filter(ag => 
        ag.gender === gender || ag.gender === 'mixed'
      );
      
      return {
        success: true,
        data: ageGroups,
        total: ageGroups.length
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Neue Altersgruppe erstellen
  async createAgeGroup(ageGroupData) {
    try {
      await this.delay();
      
      const result = await apiClient.post('/age-groups', ageGroupData);
      
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe aktualisieren
  async updateAgeGroup(id, ageGroupData) {
    try {
      await this.delay();
      
      const result = await apiClient.put(`/age-groups/${id}`, ageGroupData);
      
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe löschen
  async deleteAgeGroup(id) {
    try {
      await this.delay();
      
      await apiClient.delete(`/age-groups/${id}`);
      
      return {
        success: true,
        data: null
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Neue Funktion: Altersgruppe synchron für ein bestimmtes Alter finden
  async getAgeGroupForAgeSync(age) {
    try {
      const allAgeGroups = await this.getAllAgeGroups();
      if (!allAgeGroups.success) {
        return null;
      }
      
      const ageGroup = allAgeGroups.data.find(ag => 
        age >= ag.minAge && age <= ag.maxAge
      );
      
      return ageGroup || null;
    } catch (error) {
      console.error('Error in getAgeGroupForAgeSync:', error);
      return null;
    }
  }

  // Fallback auf Mock-Daten bei API-Fehlern
  async getMockAgeGroups() {
    const mockAgeGroups = [
      {
        id: 1,
        name: "Kinder",
        minAge: 0,
        maxAge: 12,
      },
      {
        id: 2,
        name: "Jugend",
        minAge: 13,
        maxAge: 18,
      },
      {
        id: 3,
        name: "Erwachsene",
        minAge: 19,
        maxAge: 35,
      },
      {
        id: 4,
        name: "Senioren",
        minAge: 36,
        maxAge: 55,
      },
      {
        id: 5,
        name: "Senioren Plus",
        minAge: 56,
        maxAge: 100,
      },
    ];

    return {
      success: true,
      data: mockAgeGroups,
      total: mockAgeGroups.length
    };
  }
}

// Singleton-Instanz exportieren
const ageGroupsService = new AgeGroupsService();
export default ageGroupsService; 